import { render } from "./PaysSelector.vue?vue&type=template&id=4b5af19c"
import script from "./PaysSelector.vue?vue&type=script&lang=js"
export * from "./PaysSelector.vue?vue&type=script&lang=js"

import exportComponent from "/data/www/cavilam/boutique/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__